import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordManagementScreenValidRuleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 8, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#32AF04", d: "M3.375 8a.56.56 0 0 1-.4-.168L.164 4.975a.58.58 0 0 1 .183-.931.555.555 0 0 1 .615.124L3.315 6.56 7.985.23a.57.57 0 0 1 .598-.222.56.56 0 0 1 .35.267.57.57 0 0 1-.048.64L3.823 7.772a.56.56 0 0 1-.448.228" }));
const ForwardRef = forwardRef(SvgPasswordManagementScreenValidRuleIcon);
export { ForwardRef as ReactComponent };
